import { Button } from '@mui/material';
import { Paragraph, Small } from 'components/Typography';
import DownloadTo from 'icons/DownloadTo';
const InvoiceColumnShape = [
    {
        Header: 'No',
        accessor: 'number',
    },
    {
        Header: 'Workshop Name',
        accessor: 'workshopName',
        // Cell: ({
        //   row
        // }) => {
        //   const {
        //     avatar,
        //     name
        //   } = row.original;
        //   return <Stack direction="row" spacing={1} alignItems="center">
        //         <AppAvatar src={avatar} alt={name} />
        //         <Paragraph fontSize={13} color="text.secondary">
        //           {name}
        //         </Paragraph>
        //       </Stack>;
        // }
        Cell: ({ value }) => (
            <Paragraph fontSize={13} color="text.secondary">
                {value}
            </Paragraph>
        ),
    },
    // {
    //   Header: "Location",
    //   accessor: "location",
    //   Cell: ({
    //     value
    //   }) => <Small color="text.secondary">{value}</Small>
    // },
    {
        Header: 'File Name',
        accessor: 'fileName',
        Cell: ({ value }) => (
            // <Small color="text.secondary">{format(value, "MMM dd, yyyy")}</Small>
            <Small color="text.secondary">{value}</Small>
        ),
    },
    {
        Header: 'Action',
        accessor: 'status',
        Cell: ({ value }) => (
            <Button
                color="success"
                variant="contained"
                sx={{
                    '& .MuiButton-startIcon': { margin: '0px' },
                    minWidth: 0,
                }}
                href="/assets/certificate/Symposium - Dr Jusup.pdf"
                target="_blank"
                //  fullWidth={down500}
                startIcon={<DownloadTo />}
            />
        ),
        // <Link to="/assets/certificate/Symposium - Dr Jusup.pdf" target="_blank" download>
        //   <Small sx={{
        //     width: 100,
        //     fontSize: 12,
        //     cursor: "pointer",
        //     color: "#fff",
        //     borderRadius: "4px",
        //     textAlign: "center",
        //     padding: ".2rem 1rem",
        //     // backgroundColor: value === "Complete" ? "success.main" : "error.main"
        //     backgroundColor: "success.main"
        //   }}>
        //     Download
        //     {/* {value} */}
        //   </Small>
        // </Link>
    },
    // {
    //   Header: "Action",
    //   accessor: "edit",
    //   Cell: ({
    //     value
    //   }) => <IconButton sx={{
    //     padding: 0
    //   }}>
    //         <MoreHorizontal sx={{
    //       color: "text.disabled"
    //     }} />
    //       </IconButton>
    // }
];
export default InvoiceColumnShape;
